import React, { Component } from 'react'

export default class IconFont extends Component<any> {
    render() {
        return (
            <div className={this.props.className}>
                <span style={{ color: (this.props.color || '#000') }} className="icon-font"></span>
            </div>
        )
    }
}